import { useState, useMemo, useEffect, useCallback, useRef } from "react"
import PropTypes from "prop-types"
import { TableRow, TableCell } from "@mui/material"
import TablePagination from "@mui/material/TablePagination"
import { ceil, differenceBy, size } from "lodash"
import "./style.scss"

export default function PaginationWrapper({ rows = [], rowsPerPage = 200, page: pageProp, setPage: setPageProp }) {
  const rowsRef = useRef()
  const [pageState, setPageState] = useState(0)

  const numberOfPages = useMemo(() => ceil(size(rows) / rowsPerPage), [rows, rowsPerPage])
  const page = useMemo(() => {
    if (!pageProp) { return pageState }
    return pageProp < 0 || pageProp > numberOfPages - 1 ? 0 : pageProp
  }, [pageProp, pageState, numberOfPages])

  const setPage = useCallback((newPage) => {
    if (setPageProp) {
      setPageProp(newPage)
    } else {
      setPageState(newPage)
    }
  }, [setPageProp, setPageState])

  // When rows changes, go back to the first page
  useEffect(() => {
    if (rowsRef.current && size(differenceBy(rows, rowsRef.current, "key"))) {
      setPage(0)
    }
    rowsRef.current = rows
  }, [rows, rowsRef, setPage])

  const paginationRow = useMemo(() => rows.length > rowsPerPage ? (
    <TableRow className="pagination-wrapper">
      <TableCell colSpan={3} align="right">
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(_, p) => setPage(p)}
        />
      </TableCell>
    </TableRow>
  ) : null, [rows, rowsPerPage, page, setPage])

  const start = page * rowsPerPage

  return (
    <>
      {rows.slice(start, start + rowsPerPage)}
      {paginationRow}
    </>
  )
}

PaginationWrapper.propTypes = {
  rows: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number,
  page: PropTypes.number,
  setPage: PropTypes.func,
}
